import Modal, { Prompt, ModalHeader, ModalFooter } from '@ingka/modal';
import { useGetPermissionsQuery } from '@lotta/self-service/lottery-fe/data-access-state';
import type { LocaleParams } from '@lotta/self-service/lottery-fe/types-router';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import Loading, { LoadingBall } from '@ingka/loading';
import { useEffect, useState } from 'react';
import Button from '@ingka/button';
import { MissingAccess } from '@lotta/self-service/lottery-fe/ui-common';
import styles from './AccessVerification.module.scss';
/* eslint-disable-next-line */
export interface AccessVerificationProps {}

export const AccessVerification = (props: AccessVerificationProps) => {
  const { countryCode, language } = useParams<LocaleParams>() as LocaleParams;
  const { data, isLoading } = useGetPermissionsQuery({});
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [displayModal, setDisplayModal] = useState(false);
  const [missingLottaAccess, setMissingLottaAccess] = useState(true);

  useEffect(() => {
    if (!isLoading && data) {
      if (data.permissions.length === 0) {
        setMissingLottaAccess(true);
      } else if (
        !data.permissions.some(({ retailUnitId }) => {
          return retailUnitId.toLowerCase() === countryCode.toLowerCase();
        })
      ) {
        setMissingLottaAccess(false);
        setDisplayModal(true);
      } else {
        setMissingLottaAccess(false);
      }
    }
  }, [isLoading, data, language, pathname, countryCode, navigate]);

  const onClose = () => {
    const urlSuffix = pathname.split('/').slice(2).join('/');
    const newPath = `/${data?.permissions[0].retailUnitId.toLowerCase()}/${urlSuffix}`;
    setDisplayModal(false);
    navigate(newPath);
  };

  const renderModal = () => {
    return (
      <Modal visible={displayModal} escapable={false} handleCloseBtn={onClose}>
        <Prompt
          title={t('access-verification-modal-title')}
          titleId="access-verification-modal-title"
          header={<ModalHeader />}
          footer={
            <ModalFooter>
              <Button
                id="access-verification-button-close"
                text={`${t('access-verification-button-text')}`}
                type="primary"
                onClick={onClose}
              />
            </ModalFooter>
          }
        >
          <p>{t('access-verification-modal-text')}</p>
        </Prompt>
      </Modal>
    );
  };

  const renderPage = () => {
    return missingLottaAccess ? <MissingAccess /> : displayModal ? renderModal() : <Outlet />;
  };

  return (
    <div className={styles['container']}>
      {isLoading ? (
        <Loading>
          <LoadingBall />
        </Loading>
      ) : (
        renderPage()
      )}
    </div>
  );
};
